// extracted by mini-css-extract-plugin
module.exports = {"btn-main":"Button_btn-main__3T7pf","button-loader":"Button_button-loader__205GO"};